/* RESPONSIBLE TEAM: team-pricing-and-packaging */

/**
 * Formats a price as a string: whole numbers get no decimals, fractional prices get two.
 * e.g. 35 -> "35", 8.75 -> "8.75", 19.5 -> "19.50"
 */
export function formatPriceValue(price: number): string {
  return Number.isInteger(price) ? price.toFixed(0) : price.toFixed(2);
}
